export default class LRUCache {

    size: number = 10;
    cache: Map<number, any> = new Map()

    constructor(size: number) {
        this.size = size;
    }

    get(key: number) {
        const hasKey = this.cache.has(key);
        if (hasKey) {
            const val = this.cache.get(key);
            this.cache.delete(key);
            this.cache.set(key, val);
            return val;
        } else {
            return null;
        }
    }

    set(key: number, value: any) {
        const hasKey = this.cache.has(key);
        if (hasKey) {
            this.cache.delete(key);
        }
        this.cache.set(key, value);
        if (this.cache.size > this.size) {
            this.cache.delete(this.cache.keys().next().value);
        }
    }

    delete(key: number) {
        if (this.cache.has(key)) {
            this.cache.delete(key);
        }
    }

    clear() {
        this.cache.clear();
    }
    
}